"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityCreateDto = instanceOfFacilityCreateDto;
exports.FacilityCreateDtoFromJSON = FacilityCreateDtoFromJSON;
exports.FacilityCreateDtoFromJSONTyped = FacilityCreateDtoFromJSONTyped;
exports.FacilityCreateDtoToJSON = FacilityCreateDtoToJSON;
exports.FacilityCreateDtoToJSONTyped = FacilityCreateDtoToJSONTyped;
const AddressCreateDto_1 = require("./AddressCreateDto");
const FacilityContactCreateDto_1 = require("./FacilityContactCreateDto");
/**
 * Check if a given object implements the FacilityCreateDto interface.
 */
function instanceOfFacilityCreateDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    return true;
}
function FacilityCreateDtoFromJSON(json) {
    return FacilityCreateDtoFromJSONTyped(json, false);
}
function FacilityCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'website': json['website'] == null ? undefined : json['website'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoFromJSON)(json['address']),
        'facilityContacts': json['facilityContacts'] == null ? undefined : (0, FacilityContactCreateDto_1.FacilityContactCreateDtoFromJSON)(json['facilityContacts']),
    };
}
function FacilityCreateDtoToJSON(json) {
    return FacilityCreateDtoToJSONTyped(json, false);
}
function FacilityCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'website': value['website'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoToJSON)(value['address']),
        'facilityContacts': (0, FacilityContactCreateDto_1.FacilityContactCreateDtoToJSON)(value['facilityContacts']),
    };
}
//# sourceMappingURL=FacilityCreateDto.js.map